import React from "react";
import {Box, CssBaseline} from "@mui/material";
import Topbar from "../../layout/Topbar";
import SettingsSidebar from "../SettingsSidebar";
import ReferAndEarn from "./ReferAndEarn";
import {SettingsContentBox, SettingsRoot} from "../General";

import {settingsPageStyles, SettingsPageHeader} from "../SettingsDesign";

function Referral(props) {
    return (
        <SettingsRoot>
            <CssBaseline/>
            <Topbar/>
            <SettingsSidebar {...props}/>
            <SettingsContentBox sx={settingsPageStyles}>
                <Box sx={{maxWidth: 1280, mx: 'auto', px: {xs: 0, sm: 2}, pt: 3}}>
                    <SettingsPageHeader title="Refer & Earn" description="Share Skro with your network, track your referrals, and manage your commission earnings."/>
                </Box>
                <ReferAndEarn/>
            </SettingsContentBox>
        </SettingsRoot>
    );
}

export default Referral;